<template>
  <div class="c-navigation-drawer-language">
    <template v-for="(lang, index) in info.languages">
      <div
        v-if="index > 0"
        class="o-separator"
      ></div>
      <div
        :key="lang"
        v-accessibility-focus="() => changeLanguage(lang)"
        class="o-typography--action o-typography--stateful"
        :class="{ 'is-active': lang === subscriber.currentLanguage }"
      >
        {{ lang }}
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        info: this.$services.resolve('info'),
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    methods: {
      changeLanguage(lang) {
        this.subscriber.changeLanguage(lang);
      },
    },
  };
</script>
